import { ChangeDetectorRef, Component, DoCheck, EventEmitter, Input, IterableDiffers, Output, ChangeDetectionStrategy } from '@angular/core';
import { ListViewBase } from '../list-view.base';
import { ListViewColumnFactory } from '../../../service/factory/list-view-column-factory.service';
import { CdkDragDrop, moveItemInArray, CdkDrag } from '@angular/cdk/drag-drop';
import { ListViewRow } from '../../../model/list-view-row';
import { LanguageService } from '../../../service/language.service';

@Component({
    selector: 'app-drag-drop-list-view',
    templateUrl: './drag-drop-list-view.component.html',
    styleUrls: ['./drag-drop-list-view.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DragDropListViewComponent<TSource = any> extends ListViewBase<TSource> implements DoCheck {
  constructor(
    columnFactory: ListViewColumnFactory,
    languageService: LanguageService,
    iterableDiffers: IterableDiffers,
    private readonly _cdr: ChangeDetectorRef
  ) {
    super(columnFactory, languageService, iterableDiffers);
  }

  @Input() enableDragDrop: boolean = true;
  @Input() enableDragDropItem: (item: TSource) => boolean = item => true;
  @Input() isToolbarSticky: boolean = false;
  @Input() displayToolbar: boolean = true;
  @Input() displayRowNumber: boolean = true;
  @Input() displaySummary: boolean = true;
  @Input() previewText: (item: TSource) => string;

  @Output() itemDropped = new EventEmitter<CdkDragDrop<TSource>>();

  // The drop list binds to the `rows` (ListViewRow[]) array, so the event is typed
  // over ListViewRow[]. Only the indices are used; re-emit as the public TSource shape.
  drop(event: CdkDragDrop<ListViewRow<TSource>[]>) {
    moveItemInArray(this.itemsSource, event.previousIndex, event.currentIndex);
    this.resetRows();
    this.itemDropped.emit(event as unknown as CdkDragDrop<TSource>);
  }

  sortPredicate = (index: number, item: CdkDrag<TSource>) => {
    if (this.enableDragDropItem) {
      // This works for when there's not editable item at the end.
      // If used for some more advanced scenario - needs more testing.
      let targetItem = this.itemsSource[index];
      return this.enableDragDropItem(targetItem);
    }

    return true;
  };

  ngDoCheck() {
    super.ngDoCheck();
    this._cdr.detectChanges();
  }
}
